type Route = {
  path: string
  label: string
}

type Routes = { [key: string]: Route }

export const routes: Routes = {
  activateDevice: { path: '/activate', label: 'menu.activateDevice' },
  devices: { path: '/devices', label: 'menu.devices' },
  login: { path: '/login', label: 'menu.login' },
  activateAccount: { path: '/activate-account', label: 'menu.activateAccount' },
  confirmEmailUpdate: {
    path: '/confirm-email',
    label: 'menu.confirmEmailUpdate',
  },
  editCreditCard: { path: '/edit-credit-card', label: 'menu.editCreditCard' },
  mobileApp: { path: '/mobile-app', label: 'menu.mobileApp' },
  account: { path: '/account', label: 'menu.account' },
  resetPassword: { path: '/accounts/set-password', label: '' },
  resetPasswordV2: { path: '/accounts/v2/set-password', label: '' },
  deleteAccount: { path: '/delete-account', label: 'menu.mobileApp' },
  openChat: { path: '/open-chat', label: 'menu.mobileApp' },
  openReferral: { path: '/open-referal', label: 'menu.mobileApp' },
  supportCenter: { path: '/open-support-center', label: 'menu.mobileApp' },
  support: { path: '/support', label: 'menu.mobileApp' },
  tellyPhone: { path: '/tp', label: 'menu.mobileApp' },
  getApp: { path: '/app', label: 'menu.mobileApp' },
  register: { path: '/account/register', label: 'menu.register' },
  passwordResetCheckEmail: {
    path: '/account/password-reset-check-email',
    label: 'menu.passwordResetCheckEmail',
  },
  mobileRegister: { path: '/mobile-register', label: 'menu.mobileApp' },
}
